import { ChangeEvent, FC, useEffect, useState } from "react";
import "./RequestsStats.css";
import { useAppDispatch, useAppSelector } from "../../../../hooks/ReduxHooks";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { getCommonStats } from "../../../../redux/requests/AdminRequests";
import {
  filterTickets,
  getAllCloseTickets,
} from "../../../../redux/requests/TicketRequests";

interface ITicketStatsProps {}

const TicketStats: FC<ITicketStatsProps> = () => {
  const dispatch = useAppDispatch();

  const ticketStats = useAppSelector((state) => state.admin.commonStats);
  const closeTicketState = useAppSelector(
    (state) => state.tickets.closeTickets
  );

  const [fromDate, setFromDate] = useState<string | null>(null);
  const [toDate, setToDate] = useState<string | null>(null);
  const [questionSearch, setQuestionSearch] = useState("");
  const [operatorName, setOperatorName] = useState<string>("");
  const [clientSearch, setClientSearch] = useState<string>("");

  useEffect(() => {
    const hasFilters =
      Boolean(fromDate) ||
      Boolean(toDate) ||
      Boolean(questionSearch.trim()) ||
      Boolean(operatorName.trim()) ||
      Boolean(clientSearch.trim());

    if (!hasFilters) {
      dispatch(getAllCloseTickets("closed"));
      return;
    }

    const combinedSearch = [
      questionSearch.trim(),
      operatorName.trim(),
      clientSearch.trim(),
    ]
      .filter(Boolean)
      .join(" ");

    dispatch(
      filterTickets({
        status: "closed",
        fromDate: fromDate ?? undefined,
        toDate: toDate ?? undefined,
        dateField: "closedAt",
        search: combinedSearch || undefined,
        sortBy: "closedAt",
        order: "desc",
        page: 1,
        limit: 50,
      })
    );
  }, [dispatch, fromDate, toDate, questionSearch, operatorName, clientSearch]);

  const getFromDate = (event: ChangeEvent<HTMLInputElement>) => {
    setFromDate(event.target.value || null);
  };

  const getToDate = (event: ChangeEvent<HTMLInputElement>) => {
    setToDate(event.target.value || null);
  };

  return (
    <div className="stats-page">
      <div className="stats_container">
        <h1>Статистика обращений в систему</h1>

        <div className="filters">
          <input
            type="date"
            placeholder="С даты"
            value={fromDate ?? ""}
            onChange={getFromDate}
          />
          <input
            type="date"
            placeholder="По дату"
            value={toDate ?? ""}
            onChange={getToDate}
          />
          <input
            type="text"
            placeholder="Поиск по вопросу"
            value={questionSearch}
            onChange={(e) => setQuestionSearch(e.target.value)}
          />
          <input
            type="text"
            placeholder="Поиск по имени оператора"
            value={operatorName}
            onChange={(e) => setOperatorName(e.target.value)}
          />
          <input
            type="text"
            placeholder="Клиент: имя / телефон / Telegram"
            value={clientSearch}
            onChange={(e) => setClientSearch(e.target.value)}
          />
        </div>

        <div className="stats-cards">
          <div className="card">
            <h2>Всего заявок</h2>
            <div className="value">{ticketStats.total}</div>
          </div>
          <div className="card">
            <h2>Открытые заявки</h2>
            <div className="value">{ticketStats.waiting}</div>
          </div>
          <div className="card">
            <h2>Закрытые заявки</h2>
            <div className="value">{ticketStats.completed}</div>
          </div>
          <div className="card">
            <h2>В процессе</h2>
            <div className="value">{ticketStats.inProgress}</div>
          </div>
          <div className="card">
            <h2>Средняя оценка</h2>
            <div className="value">{ticketStats.avgMark}</div>
          </div>
          <div className="card">
            <h2>Минимальная оценка</h2>
            <div className="value">{ticketStats.minMark}</div>
          </div>
          <div className="card">
            <h2>Максимальная оценка</h2>
            <div className="value">{ticketStats.maxMark}</div>
          </div>
        </div>
        <div className="dialog-list">
          <h3>Завершённые диалоги</h3>

          {closeTicketState?.length ? (
            closeTicketState.map((item) => (
              <Link
                key={item.id}
                to={`/admin/tickets/dialog/${item.id}`}
                style={{ textDecoration: "none" }}
              >
                <div
                  className="dialog-item"
                  style={{ borderBottom: "1px solid var(--light-gray)" }}
                >
                  <div className="dialog-title">Диалог #{item.id}</div>
                  <div className="dialog-meta">
                    Дата: {dayjs(item.closedAt).format("YYYY-MM-DD")} | Оценка:{" "}
                    {item.mark} | Клиент: {item.user.name}
                  </div>
                </div>
              </Link>
            ))
          ) : (
            <div style={{ padding: 12, opacity: 0.7 }}>
              Нет завершённых диалогов
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TicketStats;
